import { render } from "./CalendarEventDate.vue?vue&type=template&id=63947046"
import script from "./CalendarEventDate.vue?vue&type=script&lang=ts"
export * from "./CalendarEventDate.vue?vue&type=script&lang=ts"
script.render = render

export default script